import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import './VirtualTourBanner.scss';

export default class VirtualTourBanner extends Component {

    static get propTypes() {
        return {
            notShowPhoto: PropTypes.boolean
        };
    }

    constructor(props) {
        super(props);

        this.state = {
            showModal: false
        };
    }

    onModalShow() {
        trackEvent('Proposal', 'sellerClick3dPhotoDemo').withGA().withOptimizely();
        this.setState({
            showModal: true
        });
    }

    onModalClose() {
        this.setState({
            showModal: false
        });
    }

    render() {
        const {showModal} = this.state;
        const {notShowPhoto} = this.props;

        return (
            <div className="virtual-tour-banner">
                {notShowPhoto ? (
                    <div className="virtual-tour">
                        <div className="tour-content tour-content-full">
                            <p><img src={global.imageBaseUrl + 'proposal/house_3d.svg'} alt="3d tour icon"/></p>
                            <p className="top-msg bold">Free 3D Tour for your home</p>
                            <p className="bottom-msg">Listings with 3D photos get 50% more traffic and sell for more.</p>
                            <div className="try-out-demo">
                                <button
                                    type="button"
                                    className="btn blue"
                                    onClick={() => this.onModalShow()}>
                                    <span>Try out a demo</span>
                                </button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="virtual-tour">
                        <div className="tour-content">
                            <p className="top-msg">You are eligible for a</p>
                            <p className="top-msg bold">Free 3D Tour for your home</p>
                            <p className="bottom-msg">Listings with 3D photos get 50% more traffic and sell for more.</p>
                            <div className="try-out-demo">
                                <button
                                    type="button"
                                    className="btn blue"
                                    onClick={() => this.onModalShow()}>
                                    <span>Try out a demo</span>
                                </button>
                            </div>
                        </div>
                        <div className="tour-3d">
                            <img src={global.imageBaseUrl + 'proposal/free_3d_tour_house.svg'} alt="3d tour image"/>
                        </div>
                    </div>
                )}
                {showModal && (
                    <div className="modal nu-modal modal-3d-tour" onClick={() => this.onModalClose()}>
                        <div className="nu-modal-content">
                            <div className="modal-dialog">
                                <iframe src="https://my.matterport.com/show/?m=KwczgL9jJWY" width="1000" height="565"
                                        frameBorder="0" allowFullScreen="allowfullscreen"
                                        style="opacity: 1; visibility: visible;"/>
                                <button
                                    type="button"
                                    className="btn close-tour"
                                    onClick={() => this.onModalClose()}>
                                    <span>Close</span>
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
